<template>
  <BaseFrame
    :infosArr="infos"
  >
    <div class="container" slot="content">
      <lk-table border :columns="columns" :data="tableData"></lk-table>
      <div class="pageArea">
        <lk-page 
          :total="count" 
          show-sizer 
          show-total
          :page-size='size'
          :current.sync='page'
          :page-size-opts='sizeOptions'
          @on-change="handleChange"
          @on-page-size-change="handlePageChange"
        >
        </lk-page>
      </div>
    </div>
  </BaseFrame>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import healthInsManage from '../../services/healthInsManage';
import utils from '../../libs/utils';
export default {
  name: 'detailCheckAccount',
  components: {
    BaseFrame,
  },
  data() {
    return {
      infos: [],
      columns: [
        {
          type: 'index',
          title: '行号',
          minWidth: 116,
        },
        {
          title: '销售订单号',
          key: 'orderCode',
          minWidth: 116,
        },
        {
          title: '对账结果',
          key: 'checkResult',
          minWidth: 116,
        },
        {
          title: '结算ID',
          key: 'settlementId',
          minWidth: 116,
        },
        {
          title: '人员编号',
          key: 'psnNo',
          minWidth: 116,
        },
        {
          title: '医疗费总额',
          key: 'totalAmount',
          minWidth: 116,
        },
        {
          title: '基金支付总额',
          key: 'fundAmount',
          minWidth: 116,
        },
        {
          title: '个人账户支出',
          key: 'personAmount',
          minWidth: 116,
        },
        {
          title: '个人自费',
          key: 'personPay',
          minWidth: 116,
        },
        {
          title: 'ERP撤销状态',
          key: 'calcelStatusName',
          minWidth: 116,
        },
        {
          title: '医保退费结算标志',
          key: 'refundStatus',
          minWidth: 116,
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 116,
        },
      ],
      page: 1,
      size: 20,
      count: 0,
      sizeOptions: [10, 20, 30, 40],
      orderInfo: {},
      tableData: [],
    };
  },
  methods: {
    getData() {
      const params = {
        logId: this.orderInfo.id || '',
        insutype: this.orderInfo.insutype || '',
        beginTime: this.orderInfo.beginTime || '',
        endTime: this.orderInfo.endTime || '',
        clrType: this.orderInfo.clrType || '',
        page: this.page,
        size: this.size,
        medicalSubject: this.orderInfo.medicalSubject || '',
      };
      healthInsManage.checkDetail(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list || [];
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        };
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleChange(page) {
      this.page = page;
      this.getData();
    },
    handlePageChange(size) {
      this.size = size;
    },
  },
  mounted() {
    this.orderInfo = this.$route.query || {};
    this.infos = [
      {
        name: '对账门店:',
        value: this.orderInfo.storeName || '',
      },
      {
        name: '对账日期范围:',
        value: this.orderInfo.dateRange || '',
      },
      {
        name: '医疗费总额:',
        value: this.orderInfo.totalAmount || '',
      },
      {
        name: '基金支付总额:',
        value: this.orderInfo.fundAmount || '',
      },
      {
        name: '个人账户支出:',
        value: this.orderInfo.personAmount || '',
      },
    ];
    this.getData();
  },
}
</script>

<style lang="less" scoped>
  .btns {
    margin-bottom: 12px;
  }
  .pageArea {
    display: flex;
    margin-top: 20px;
    flex-direction: row-reverse;
  }
</style>